import { Loader } from "@mantine/core";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { PermissionsPanel } from "../../components/Settings/Permissions/PermissionsPanel";
import { useActiveOrganization } from "../../hooks/useActiveOrganization";

export const Route = createFileRoute("/settings/permissions")({
	component: PermissionsRoute,
});

// Admin-only: `adminOnly` in sections.ts hides the nav link, but the route must
// guard itself too (mirrors invites.tsx / requests.tsx) so a direct URL can't
// reach the panel. Server-side enforcement still applies regardless.
function PermissionsRoute() {
	const { activeOrganization, loading } = useActiveOrganization();
	const isAdmin = activeOrganization?.role === "ADMIN";
	const navigate = useNavigate();

	useEffect(() => {
		if (loading) return;
		if (!isAdmin) {
			navigate({ to: "/settings/account" });
		}
	}, [loading, isAdmin, navigate]);

	if (loading || !isAdmin || !activeOrganization) {
		return (
			<div className="flex items-center justify-center min-h-[40vh]">
				<Loader size="lg" />
			</div>
		);
	}

	return <PermissionsPanel />;
}
